/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalculationParameterUnit = {
    Euro: 'Euro',
    Percentage: 'Percentage'
} as const;
export type CalculationParameterUnit = typeof CalculationParameterUnit[keyof typeof CalculationParameterUnit];


export function instanceOfCalculationParameterUnit(value: any): boolean {
    for (const key in CalculationParameterUnit) {
        if (Object.prototype.hasOwnProperty.call(CalculationParameterUnit, key)) {
            if (CalculationParameterUnit[key as keyof typeof CalculationParameterUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalculationParameterUnitFromJSON(json: any): CalculationParameterUnit {
    return CalculationParameterUnitFromJSONTyped(json, false);
}

export function CalculationParameterUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterUnit {
    return json as CalculationParameterUnit;
}

export function CalculationParameterUnitToJSON(value?: CalculationParameterUnit | null): any {
    return value as any;
}

export function CalculationParameterUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): CalculationParameterUnit {
    return value as CalculationParameterUnit;
}

